import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/Orders`;

export const fetchOrders = async (branchId) => {
  try {
    const url = branchId ? `${API_URL}?branchId=${branchId}` : API_URL;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
};

export const updateOrderStatus = async (orderId, newStatus) => {
  try {
    const response = await axios.put(`${API_URL}/UpdateStatus`, {
      OrderId: orderId,
      NewStatus: newStatus
    });
    return response.data;
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
};

export const deleteOrder = async (orderId) => {
  try {
    const response = await axios.delete(`${API_URL}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting order:', error);
    throw error;
  }
};

export const sendNotification = async (orderId) => {
  try {
    const response = await axios.post(`${API_URL}/SendNotification`, { OrderId: orderId });
    return response.data;
  } catch (error) {
    console.error('Error sending notification:', error);
    throw error;
  }
};
